const getApi_Uri = (hostName: string, isMacOS: boolean) => {
  if (hostName.includes('use.confirmedapp.com'))
    return 'https://confirmedservice.confirmedapp.com/api';

  if (hostName.includes('staging2.confirmedapp.com'))
    return 'https://confirmedservice-staging.azurewebsites.net/api';
  else
    return isMacOS
      ? 'https://confirmedservice-staging.azurewebsites.net/api'
      : 'http://localhost:39955/api';
};

export default getApi_Uri;
